import { render } from "./SettingsKioskBucketSize.vue?vue&type=template&id=60203d40&scoped=true"
import script from "./SettingsKioskBucketSize.vue?vue&type=script&lang=js"
export * from "./SettingsKioskBucketSize.vue?vue&type=script&lang=js"

import "./SettingsKioskBucketSize.vue?vue&type=style&index=0&id=60203d40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60203d40"]])

export default __exports__